import script from "./TerminalInstr.vue?vue&type=script&setup=true&lang=ts"
export * from "./TerminalInstr.vue?vue&type=script&setup=true&lang=ts"

import "./TerminalInstr.vue?vue&type=style&index=0&id=a40c1f6c&lang=css"

const __exports__ = script;

export default __exports__